export class ListNotebooksResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "notebooks",
            "baseName": "notebooks",
            "type": "Array<Notebook>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListNotebooksResponse.attributeTypeMap;
    }
    constructor() {
    }
}
